<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="4" v-for="(v,k) in listCertificados" :key="k">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on">
                            </v-img>
                        </template>
                        <span>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td> <strong class="white--text body-2">Producto: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.producto"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Póliza: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.poliza"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Certficado: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.idCertificado"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Fecha Vigencia: </strong>
                                        </td>
                                        <td class="body-2" v-html="`${v.fechaDesde} - ${v.fechaHasta}`"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Marca: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.marca"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Modelo: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.modelo"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Año: </strong> </td>
                                        <td class="body-2" v-html="v.anio"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Respaldado: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.aseguradora"> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </span>
                    </v-tooltip>
                    <div class="text-center">
                        <h3 class="headline">Placa: {{ v.placa }}</h3>
                    </div>
                    <div>
                        <v-btn block rounded dark color="primary" @click="verResumen(v)">Ver Resumen Póliza</v-btn>
                    </div>
                    <div class="mt-3">
                        <v-btn block rounded dark color="secondary" @click="verDocumento(v)">Ver Documentos</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformacionCertificadoComponent',
        inject:['setData','setStep'],
        props:{
            active:{
                type:Boolean,
                default:false
            },
            idCliente:{
                type:String,
                default:''
            },
            obBusqueda:{
                type:Object,
                default:{}
            },
            listCertificados:{
                type:Array,
                default: () => []
            }
        },
        watch:{
            active(val){
                if(val && _.size(this.listCertificados) == 0){
                    this.onListarCertificados();
                }
            }
        },
        created(){
            this.onListarCertificados();
        },
        methods:{
            onListarCertificados(){
                var error = 'E';
                var o = {
                    opcion:'L_CERTIFICADOS_VEHICULO',
                    idCliente:this.idCliente
                };
                this.setData('listGeneral.listCertificados',[]);

                axios.post(`${BASE_URI}administrador/consulta-datos-poliza/listar`,o)
                     .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                            this.setData('listGeneral.listCertificados',r.data.data);
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     })
            },
            verResumen(v){
                var idCer = _.get(this.obBusqueda,'idCertificado');
                var idPol = _.get(this.obBusqueda,'idPoliza');

                if( _.toNumber(idCer) != _.toNumber(v.idCertificado) || _.toNumber(idPol) != _.toNumber(v.idPoliza) ){
                    var l = ['listCoberturas','listBeneficios','listAccesorios','listDocumentos'];
                    _.forEach(l,(vv)=>{
                        this.setData(`listGeneral.${vv}`,[]);
                    });
                }
                this.setData('obSearch',v);
                this.setStep(3);
            },
            verDocumento(v){
                var idCer = _.get(this.obBusqueda,'idCertificado');
                var idPol = _.get(this.obBusqueda,'idPoliza');
                if( _.toNumber(idCer) != _.toNumber(v.idCertificado) || _.toNumber(idPol) != _.toNumber(v.idPoliza) )
                    this.setData(`listGeneral.listDocumentos`,[]);
                
                this.setData('obSearch',v);
                this.setStep(6);
            }
        }
    }
</script>
